/*
 * COPYRIGHT. HSBC HOLDINGS PLC 2017. ALL RIGHTS RESERVED.
 *
 * This software is only to be used for the purpose for which it has been
 * provided. No part of it is to be reproduced, disassembled, transmitted,
 * stored in a retrieval system nor translated in any human or computer
 * language in any way or for any other purposes whatsoever without the
 * prior written consent of HSBC Holdings plc.
 *
 */

import { Component } from 'react';
import { isEqual } from '../../../../utils'

export default class BaseComponent extends Component {
    
    shouldComponentUpdate(nextProps, nextState) {
        const needUpdate = !isEqual(nextProps, this.props) || !isEqual(nextState, this.state)
        return needUpdate
    }
}


// WEBPACK FOOTER //
// ./src/shared/AOForm/components/BaseComponent/index.js